import { Link } from 'react-router-dom';
import { FiMapPin, FiPhone, FiMail } from 'react-icons/fi';

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-3 gap-8">
          {/* About */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">The Hyderabad Library</h3>
            <p className="text-sm leading-relaxed">
              Where books travel and stories connect. Access thousands of books with our affordable monthly membership.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/catalog" className="hover:text-amber-400 transition-colors">
                  Browse Catalog
                </Link>
              </li>
              <li>
                <Link to="/my-library?section=payments" className="hover:text-amber-400 transition-colors">
                  Membership Plans
                </Link>
              </li>
              <li>
                <Link to="/faqs" className="hover:text-amber-400 transition-colors">
                  FAQs
                </Link>
              </li>
              <li>
                <Link to="/policies" className="hover:text-amber-400 transition-colors">
                  Terms & Policies
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="https://maps.app.goo.gl/2EucnVthv76SzcCw6"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start space-x-3 hover:text-amber-400 transition-colors"
                  data-testid="footer-map-link"
                >
                  <FiMapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                  <span>
                    The Hyderabad Library, 2nd Floor<br />
                    BBR Forum, Road No. 2<br />
                    Banjara Hills, Hyderabad<br />
                    Landmark: same building as KSR Eyecare
                  </span>
                </a>
              </li>
              <li>
                <a
                  href="tel:7901662333"
                  className="flex items-center space-x-3 hover:text-amber-400 transition-colors"
                  data-testid="footer-phone-link"
                >
                  <FiPhone className="w-5 h-5" />
                  <span>7901662333</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:thehyderabadlibrary@gmail.com"
                  className="flex items-center space-x-3 hover:text-amber-400 transition-colors"
                  data-testid="footer-email-link"
                >
                  <FiMail className="w-5 h-5" />
                  <span>thehyderabadlibrary@gmail.com</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm">
          <p>© {currentYear} The Hyderabad Library. All rights reserved.</p>
          <div className="mt-3 flex flex-wrap justify-center gap-4 text-gray-500">
            <Link to="/policies/terms" className="hover:text-amber-400 transition-colors">Terms & Conditions</Link>
            <span>|</span>
            <Link to="/policies/privacy" className="hover:text-amber-400 transition-colors">Privacy Policy</Link>
            <span>|</span>
            <Link to="/policies/refund" className="hover:text-amber-400 transition-colors">Refund Policy</Link>
            <span>|</span>
            <Link to="/policies/cancellation" className="hover:text-amber-400 transition-colors">Cancellation Policy</Link>
          </div>
          <p className="mt-3 text-gray-500">
            Paid pickup & delivery service available every Thursday
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
